import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n/i18n"; // Initialize i18n

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Enhanced service worker registration for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js', {
        scope: '/'
      });
      
      console.log('PWA: Service worker registered successfully:', registration);
      
      // Handle service worker updates - AUTO REFRESH on new version
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        console.log('PWA: New service worker found, installing...');
        
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('PWA: New version available - activating immediately');
            // Tell the new service worker to take over immediately
            newWorker.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });
      
      // When new service worker takes control, refresh the page automatically
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('PWA: New service worker activated - refreshing page');
        window.location.reload();
      });
      
      // Check for updates every time the app loads
      registration.update();
      
      // Handle service worker messages
      navigator.serviceWorker.addEventListener('message', (event) => {
        console.log('PWA: Message from service worker:', event.data);
        
        if (event.data.type === 'VERSION') {
          console.log('PWA: Service worker version:', event.data.version);
        }
      });
      
      // Periodic sync registration for background updates
      if ('periodicSync' in window.ServiceWorkerRegistration.prototype) {
        try {
          await registration.periodicSync.register('content-sync', {
            minInterval: 24 * 60 * 60 * 1000, // 24 hours
          });
          console.log('PWA: Periodic sync registered');
        } catch (error) {
          console.log('PWA: Periodic sync registration failed:', error);
        }
      }
      
    } catch (error) {
      console.error('PWA: Service worker registration failed:', error);
    }
  });
  
  // Handle PWA install prompt
  let deferredPrompt;
  window.addEventListener('beforeinstallprompt', (e) => {
    console.log('PWA: Install prompt triggered');
    e.preventDefault();
    deferredPrompt = e;
    
    // Store for PWA install prompt component
    window.deferredPWAPrompt = e;
  });
  
  // Handle PWA installation success
  window.addEventListener('appinstalled', () => {
    console.log('PWA: App installed successfully');
    deferredPrompt = null;
    window.deferredPWAPrompt = null;
  });
}
